<template>
  <Modal
    :value="visible"
    :mask-closable="false"
    :footer-hide="true"
    width="420"
    class-name="coupon-confirm-modal"
    @on-visible-change="onVisibleChange"
  >
    <div class="modal-header">
      <span class="modal-title">{{ title }}</span>
    </div>

    <div class="modal-body">
      <div class="tip-text">{{ tip.split("|")[0] }}</div>
      <div class="tip-text warning-text">{{ tip.split("|")[1] }}</div>
    </div>

    <div class="modal-footer">
      <div class="btn cancel" @click="onCancel">取消</div>
      <div class="btn confirm" @click="onConfirm">{{ confirmText }}</div>
    </div>
  </Modal>
</template>

<script>
// 暂停/结束/删除 优惠券确认弹窗（纯静态交互，接口联调由父组件 confirm 回调处理）
export default {
  name: "CouponConfirmModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // pause 暂停 | finish 结束 | delete 删除 | batch_delete 批量删除
    type: {
      type: String,
      default: "pause",
    },
  },
  computed: {
    title() {
      const map = {
        pause: "确定要暂停优惠券吗?",
        finish: "确定要结束优惠券吗?",
        delete: "确定要删除优惠券吗?",
        batch_delete: "确定要删除选中的优惠券吗?",
      };
      return map[this.type] || "";
    },
    tip() {
      const map = {
        pause: "活动暂停后，将停止发放优惠券，消费者已领取的券|在有效期内仍可继续使用",
        finish: "活动结束后，将停止发放优惠券，消费者已领取的券|在有效期内仍可继续使用",
        delete: "删除后不可恢复|请谨慎操作",
        batch_delete: "删除后不可恢复|请谨慎操作",
      };
      return map[this.type] || "";
    },
    confirmText() {
      return this.type === "batch_delete" ? "确定" : "确定";
    },
  },
  methods: {
    onVisibleChange(val) {
      if (!val) {
        this.onCancel();
      }
    },
    onCancel() {
      this.$emit("update:visible", false);
    },
    onConfirm() {
      this.$emit("confirm", this.type);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .coupon-confirm-modal {
  text-align: left;
  line-height: 1.5;
  .ivu-modal-content {
    border-radius: 10px;
  }

  .ivu-modal-body {
    padding: 0;
  }

  .ivu-modal-close {
    top: 14px;
    right: 14px;
  }
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px 0 24px;
  // border-bottom: 1px solid #f0f0f0;
  position: relative;

  .modal-title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }
}

.modal-body {
  padding: 24px;

  .tip-text {
    font-size: 14px;
    color: #333333;
    text-align: center;
  }
  .warning-text {
    color: #FF5000;
  }
}

.modal-footer {
  padding-top: 16px;
  padding-bottom: 24px;
  display: flex;
  justify-content: center;
  gap: 10px;

  .btn {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;

    &.cancel {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      color: #666666;
      font-weight: bold;

      &:hover {
        border-color: #cccccc;
      }
    }

    &.confirm {
      width: 120px;
      background: #ff5967;
      color: #ffffff;
      font-weight: bold;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
